import React from "react";
import { Pagination, A11y, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import hero1 from "../../images/hero/image-3.jpg";
import hero2 from "../../images/hero/image-4.jpg";
import shape from "../../images/hero/shape.svg";

const Hero3: React.FC = () => {
  return (
    <section className="hero wpo-hero-slider-s3">
      <div className="swiper-container">
        <Swiper
          modules={[Pagination, A11y, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          loop={true}
          pagination={{ clickable: true }}
          speed={1800}
          parallax={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
        >
          {/* --- Slide One --- */}
          <SwiperSlide>
            <div
              className="slide-inner slide-bg-image"
              style={{ backgroundImage: `url(${hero1})` }}
            >
              <div className="container">
                <div className="slide-content">
                  <div
                    data-swiper-parallax="300"
                    className="slide-title wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    <h2>
                      Wilson
                      <img className="text-image" src={shape} alt="flower shape" />
                      <span>June 15, 2026.</span>
                    </h2>
                    <h2>
                      <span className="second-items">Save The Date</span>
                      Amanda
                    </h2>
                  </div>

                  <div
                    data-swiper-parallax="400"
                    className="slide-text wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <p>
                      We are getting Married. Let's create a remarkable journey
                      where our dreams become realities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* --- Slide Two --- */}
          <SwiperSlide>
            <div
              className="slide-inner slide-bg-image"
              style={{ backgroundImage: `url(${hero2})` }}
            >
              <div className="container">
                <div className="slide-content">
                  <div
                    data-swiper-parallax="300"
                    className="slide-title wow fadeInUp"
                    data-wow-delay="0.1s"
                  >
                    <h2>
                      Wilson
                      <img className="text-image" src={shape} alt="flower shape" />
                      <span>June 15, 2026.</span>
                    </h2>
                    <h2>
                      <span className="second-items">Save The Date</span>
                      Amanda
                    </h2>
                  </div>

                  <div
                    data-swiper-parallax="400"
                    className="slide-text wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <p>
                      We are getting Married. Let's create a remarkable journey
                      where our dreams become realities.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default Hero3;
